module.exports = __webpack_public_path__ + "media/images/gateway/3-a1a888aeb9d16e396f4f3550290331d4.png";